<div *ngIf="template" class="d-flex gap-3">
    <div style="min-width: 180px" class="d-flex gap-2 flex-column">
        <div class="text-nowrap">
            <strong><small>应用条件</small></strong>
        </div>
        <p-tag
            *ngIf="template.region"
            class="text-nowrap"
            severity="info"
            [value]="'区域: ' + RegionId[template.region]"
        />
        <p-tag
            *ngIf="template.organizationId"
            class="text-nowrap"
            severity="info"
            [value]="'组织: ' + organization?.name"
        />
        <p-tag
            *ngIf="template.locale != null"
            class="text-nowrap"
            severity="info"
            [value]="'语言: ' + template.locale"
        />
        <p-tag
            *ngIf="template.hasTreatmentPlan != null"
            severity="info"
            class="text-nowrap"
            [value]="'特殊要求: ' + (template.hasTreatmentPlan ? '有' : '无')"
        />
        <p-tag
            *ngIf="template.fabricationMethod != null"
            severity="info"
            class="text-nowrap"
            [value]="'打印服务: ' + (template.fabricationMethod === FabricationMethod.printAndShip ? '是' : '否')"
        />
        <p-tag
            *ngIf="template.isFirstOrSecondOrderOnly != null"
            severity="info"
            class="text-nowrap"
            [value]="'特定单次: ' + (template.isFirstOrSecondOrderOnly ? '首单/第二单' : '无')"
        />

        <div class="d-flex gap-2">
            <p-button
                label="编辑"
                styleClass="p-button-xs"
                [outlined]="true"
                severity="secondary"
                (onClick)="edit.emit(template)"
            />

            <p-button
                label="删除"
                styleClass="p-button-xs"
                [outlined]="true"
                severity="secondary"
                (onClick)="onClickDelete($event)"
            />
        </div>
    </div>

    <div class="d-flex gap-2 flex-column">
        <div>
            <strong><small>常规消息</small></strong>
        </div>
        <app-rich-text [text]="template.message" />
    </div>

    <div *ngIf="template.revisionMessage" class="d-flex gap-2 flex-column">
        <div class="text-nowrap">
            <strong><small>返修消息</small></strong>
        </div>
        <div>
            <app-rich-text [text]="template.revisionMessage" />
        </div>
    </div>
</div>

<p-confirmPopup key="confirm-delete-message-template" />
